import { render, staticRenderFns } from "./contractors-payments-modal.vue?vue&type=template&id=dd995eea&scoped=true&"
import script from "./contractors-payments-modal.vue?vue&type=script&lang=js&"
export * from "./contractors-payments-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd995eea",
  null
  
)

export default component.exports